// extracted by mini-css-extract-plugin
export default {"wrappedSpinner":"styles_wrappedSpinner__HE1Gw","spinner":"styles_spinner__Zu60w","spin":"styles_spin__wHOPr"};